<template>
  <button
    type="button"
    class="a11y-toggle"
    :class="{
      active: accessibilityEnabled,
      'a11y-toggle--mobile': mobile,
      'a11y-toggle--banner': banner
    }"
    :aria-pressed="accessibilityEnabled"
    :aria-label="accessibilityEnabled ? m.nav.accessibilityOn : m.nav.accessibilityOff"
    :title="mobile ? undefined : m.nav.accessibilityMode"
    @click="toggleAccessibility"
  >
    <svg class="a11y-toggle-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 4.5C7 4.5 2.7 7.6 1 12c1.7 4.4 6 7.5 11 7.5s9.3-3.1 11-7.5C21.3 7.6 17 4.5 12 4.5z" fill="none" stroke="currentColor" stroke-width="1.8"/>
      <circle cx="12" cy="12" r="3.25" fill="currentColor"/>
    </svg>
    <span :class="{ 'a11y-toggle-label': !mobile }">{{ mobile ? m.nav.accessibilityMode : 'A+' }}</span>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  mobile?: boolean
  banner?: boolean
}>()

const { messages: m } = useI18n()
const { accessibilityEnabled, toggleAccessibility } = useAccessibility()
</script>